// src/pages/ContactPage.jsx
import {
  Box,
  Button,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Text,
  Textarea,
  VStack,
  Image,
  Icon,
  Link,
  SimpleGrid,
  Stack,
  HStack,
} from "@chakra-ui/react";
import {
  FaEnvelope,
  FaPhone,
  FaFacebook,
  FaInstagram,
  FaXTwitter,
  FaLinkedin,
} from "react-icons/fa6";
import { FaComments } from "react-icons/fa"; // For Live Chat
import Success from "component/home/component/Success";
import Footer from "component/header/Footer";
import headingRightImg from "../../assets/home/careerpg.png";
import socialLeftImg from "../../assets/home/badgered.png";
import useScrollAnimation from "component/useScrollAnimation";

const ContactPage = () => {
  useScrollAnimation();
  return (
    <>
    <Box bgColor={'#FCFBF7'}>
      <Box px={{ base: 4, md: 10 }}  py={24} maxW="7xl" mx="auto">
        {/* Heading Section */}
        <VStack spacing={4} textAlign="center" mb={10}>
          <Heading fontSize={{ base: "2xl", md: "3xl" }} color="teal.700" className="fade-in-up">
            Excited to Craft Something Amazing?
          </Heading>
          <Text fontSize={{ base: "sm", md: "md" }} color="gray.600" maxW="3xl" className="fade-in-up">
            Let’s transform your ideas into a roaring success. As a trusted
            digital marketing company in Jaipur and one of the best SEO
            companies in India, we’re here to help. Reach out to us and
            experience the magic of Marwadi-style innovation!
          </Text>
        </VStack>

        <Image
          src={headingRightImg}
          alt="Decorative"
          position="absolute"
          top={{ base: "3%", md: "90px" }}
          right={{ base: "0", md: "290px" }}
          boxSize={{ base: "60px", md: "100px" }}
          zIndex={-1}
          display={{ base: "block", md: "block" }}
          data-animated = 'true'
          className="fade-in-up"
        />

        {/* Contact Form Section */}
        <Flex
          direction={{ base: "column", md: "row" }}
          gap={10}
          align="flex-start"
          justify="space-between"
        >
          {/* Left: Contact Form */}
          <Box flex={1} w="full">
            <Heading size="md" mb={2} className="fade-in-up">
              Contact us
            </Heading>
            <Text mb={6} fontSize="sm" color="gray.500" className="fade-in-up">
              Ready to Create Something Extraordinary?
            </Text>

            <VStack spacing={4} align="stretch">
              <FormControl>
                <FormLabel>Name</FormLabel>
                <Input placeholder="Enter your name" />
              </FormControl>

              <FormControl>
                <FormLabel>Phone</FormLabel>
                <Input placeholder="Enter your phone number" />
              </FormControl>

              <FormControl>
                <FormLabel>Email</FormLabel>
                <Input type="email" placeholder="Enter your email" />
              </FormControl>

              <FormControl>
                <FormLabel>Message</FormLabel>
                <Textarea placeholder="Type your message..." rows={4} />
              </FormControl>

              <Checkbox colorScheme="teal" fontSize="sm">
                I accept the{" "}
                <Text as="span" color="blue.500">
                  Terms
                </Text>
              </Checkbox>

              <Button colorScheme="teal" mt={2} w="fit-content">
                Submit
              </Button>
            </VStack>
          </Box>

          {/* Right: Image */}
          <Box flex={1} w="full" display="flex" justifyContent="center">
            {/* <Image
              src={contact}
              alt="Man doing Namaste"
              borderRadius="md"
              objectFit="cover"
              maxH="600px"
              w="100%"
              maxW="400px"
              bg="gray.200"
            /> */}
            <iframe title="google map location" src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d113891.95647889466!2d75.7362637264635!3d26.86781261186513!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x396db72c1b6220ef%3A0x5185845015278001!2sSansthan%20Path%2C%20Jhalana%20Doongri%2C%20Jaipur%2C%20Rajasthan%20302017!3m2!1d26.8678365!2d75.8186652!5e0!3m2!1sen!2sin!4v1744200108612!5m2!1sen!2sin" width="600" height="450" style={{border:'0'}} allowFullScreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          </Box>
        </Flex>

        {/* Contact Info Section */}
        <Box mt={20} className="fade-in-up">
          <SimpleGrid
            columns={{ base: 1, sm: 2, md: 3 }}
            spacing={8}
            mb={10}
            bg="#F4EDDC"
            p={16}
          >
            <VStack align="start">
              <Icon as={FaEnvelope} boxSize={6} color="teal.700" />
              <Text fontWeight="bold">Email</Text>
              <Link href="mailto:contact@doggleindia.com" color="teal.700">
                contact@doggleindia.com
              </Link>
            </VStack>

            <VStack align="start">
              <Icon as={FaComments} boxSize={6} color="teal.700" />
              <Text fontWeight="bold">Live Chat</Text>
              <Link href="tel:+918503934119" color="teal.700">
                +91 850-393-4119
              </Link>
            </VStack>

            <VStack align="start">
              <Icon as={FaPhone} boxSize={6} color="teal.700" />
              <Text fontWeight="bold">Phone</Text>
              <Link href="tel:+918503934119" color="teal.700">
                +91 850-393-4119
              </Link>
            </VStack>
          </SimpleGrid>

          <Box position="relative" mt={{ base: 10, md: 40 }}>
            <Image
              src={socialLeftImg}
              alt="Left decoration"
              position="absolute"
              left={{ base: "2px", md: "-130px" }}
              top={{ base: "110%", md: "100%" }}
              transform="translateY(-50%)"
              boxSize={{ base: "60px", md: "120px" }}
              zIndex={0}
              display={{ base: "block", md: "block" }}
              data-animated = 'true'
              className="fade-in-up"
            />

            <VStack align="start" bg="#F4EDDC" p={4} spacing={4} className="fade-in-up">
              <Text fontWeight="bold">Follow Us</Text>
              <Stack direction={{ base: "column", md: "row" }} spacing={{base:4,md:32}}>
                <Link href="#" isExternal>
                <HStack>
                  <Icon as={FaFacebook} boxSize={5} />
                  <Text as="span" >
                    Facebook
                  </Text>
                  </HStack>
                </Link>
                <Link href="#" isExternal>
                <HStack>
                
                  <Icon as={FaInstagram} boxSize={5} />
                  <Text as="span" >
                    Instagram
                  </Text>
                  </HStack>
                </Link>
                <Link href="#" isExternal>
                <HStack>
                  <Icon as={FaXTwitter} boxSize={5} />
                  <Text as="span" >
                    Twitter
                  </Text>
                  </HStack>
                </Link>
                <Link href="#" isExternal >
                <HStack>
                  <Icon as={FaLinkedin} boxSize={5} />
                  <Text as="span" >
                    LinkedIn
                  </Text>
                  </HStack>
                </Link>
              </Stack>
            </VStack>
          </Box>
        </Box>
      </Box>
      </Box>
      <Success />
      <Footer />
    </>
  );
};

export default ContactPage;
